import type { IconNode } from '../types';

/**
 * @name high-heel
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAzYzYgNiA4LjQgMTAuNSA5LjggMTIgLjkgMSAyLjUgMS4zIDMuNy42LjMtLjIuNS0uMy43LS42LjYuMyAzLjggMy4xIDMuOCA1IDAgMS0xIDEtMSAxaC03Yy0xIDAtMi0uNS0yLjYtMS41TDEwLjEgMTdjLS45LTEuNi0yLjItMy0zLjctNC4yTDQgMTFhNSA1IDAgMCAxIDAtOCIgLz4KICA8cGF0aCBkPSJtMi41NiA5LjMuNiAxLjFDNC4yIDEyLjYgNSAxNi41IDUgMjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/high-heel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const highHeel: IconNode = [
  [
    'path',
    {
      d: 'M4 3c6 6 8.4 10.5 9.8 12 .9 1 2.5 1.3 3.7.6.3-.2.5-.3.7-.6.6.3 3.8 3.1 3.8 5 0 1-1 1-1 1h-7c-1 0-2-.5-2.6-1.5L10.1 17c-.9-1.6-2.2-3-3.7-4.2L4 11a5 5 0 0 1 0-8',
      key: '1xy4gs',
    },
  ],
  ['path', { d: 'm2.56 9.3.6 1.1C4.2 12.6 5 16.5 5 21', key: 'tyi6z9' }],
];

export default highHeel;
